import {
  EnvelopeIcon,
  HomeIcon,
  RectangleGroupIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/solid";
import {
  ArchiveIcon,
  BoxIcon,
  HandCoinsIcon,
  LineChart,
  Newspaper,
  Presentation,
  ShoppingBagIcon,
  ShoppingBasket,
  UserRoundIcon,
} from "lucide-react";

export const navListMenuItems = [
  {
    title: "Adapter",
    description: "Iphone, Samsung, Oppo, Vivo, Others",
    image: "adapter.jpg",
    subLink: "adapter",
  },
  {
    title: "Battery",
    description: "Iphone, Samsung, Oppo, Vivo, Others",
    image: "battery.jpg",
    subLink: "battery",
  },
  {
    title: "Bluetooth Speaker",
    description: "JBL, Sony, Boat, Others",
    image: "bluetooth_speaker.jpg",
    subLink: "bluetooth-speaker",
  },
  {
    title: "Cover",
    description: "Silicon, Rainbow, Jelly, Flip, Others",
    image: "cover.jpeg",
    subLink: "cover",
  },
  {
    title: "Data Cable",
    description: "Target, Samsung, Iphone, Vivo, Oppo, Others",
    image: "datacable.webp",
    subLink: "data-cable",
  },
  {
    title: "Earphone",
    description: "Boats, Others",
    image: "earphone.jpg",
    subLink: "earphone",
  },
  {
    title: "Memory Card",
    description: "Samsung, Sandisk, Others",
    image: "memory.jpg",
    subLink: "memory-card",
  },
  {
    title: "Neckband",
    description: "Hamour, Boat, Ticon, Rivano, Others",
    image: "neckband.jpg",
    subLink: "neckband",
  },
  {
    title: "Pendrive",
    description: "Samsung, Sandisk, Others",
    image: "pendrive.jpg",
    subLink: "pendrive",
  },
  {
    title: "Tempered Glass",
    description: "11D, D+, KAWIO, IT's Me, GTel, Others",
    image: "tempered_glass.jpg",
    subLink: "tempered-glass",
  },
  {
    title: "Touch Glass",
    description: "MI, Oppo, Vivo, Samsung, Iphone, Others",
    image: "touch_glass.jpg",
    subLink: "touch-glass",
  },
  {
    title: "Touch Screen",
    description: "MI, Oppo, Vivo, Samsung, Iphone, Others",
    image: "touch.jpg",
    subLink: "touch-screen",
  },
  {
    title: "Mobile Accessories",
    description: "Cover, Data Cable, Adapter, Earphone",
    image: "access.webp",
    subLink: "mobile-accessories",
  },
  {
    title: "Mobile Spare Parts",
    description: "Subboard, Flex, Earpiece, Speaker Module, Paste, Others",
    image: "spare.webp",
    subLink: "mobile-spare-parts",
  },
  {
    title: "Mobile Display Screen",
    description: "Realme, Samsung, Iphone, Oppo, Vivo, Others",
    image: "combo.webp",
    subLink: "mobile-display-screen",
  },
];

export const menuItems = [
  { title: "Home", link: "/", icon: HomeIcon },
  // {title: 'Services'},
  // {title: 'About Us'},
  {
    title: "Categories",
    link: "category",
    subMenu: true,
    subMenuItems: navListMenuItems,
    icon: RectangleGroupIcon,
  },
  {
    title: "Repairing Services",
    link: "/repairing_services",
    icon: WrenchScrewdriverIcon,
  },
  { title: "Courier Services", link: "/courier_services", icon: EnvelopeIcon },
  // {title: 'Blogs'},
  // {title: 'Contact Us'},
];

export const adminItems = [
  { title: "Overview", link: `/admin`, icon: LineChart },
  { title: "Banners", link: `/admin/banners`, icon: Presentation },
  { title: "Blogs", link: `/admin/blogs`, icon: Newspaper },
  { title: "Brands", link: `/admin/brands`, icon: ShoppingBasket },
  { title: "Categories", link: `/admin/categories`, icon: ArchiveIcon, subMenu: false, subMenuItems: navListMenuItems },
  { title: "Products", link: `/admin/products`, icon: ShoppingBagIcon },
  { title: "Orders", link: `/admin/orders`, icon: BoxIcon },
  { title: "Payments", link: `/admin/payments`, icon: HandCoinsIcon },
  { title: "Users", link: `/admin/users`, icon: UserRoundIcon },
];
